import { useState } from 'react'
import { useForm } from 'react-final-form'
import { UseSubmitStateHook } from './types'

export const useFormSubmitState: UseSubmitStateHook = () => {
    const [s, setS] = useState({
        submitting: false,
        error: null,
        valid: true
    })

    useForm().subscribe(
        f => {
            const { submitError, submitting, hasValidationErrors } = f
            if (
                s.submitting !== submitting ||
                s.error !== submitError ||
                !s.valid !== hasValidationErrors
            )
                setS({
                    submitting,
                    error: submitError,
                    valid: !hasValidationErrors
                })
        },
        {
            submitting: true,
            submitError: true,
            hasValidationErrors: true
        }
    )
    return s
}
